
/**
 * Regular expression used to validate a slug.
 */

const slugPattern = '^[a-z0-9_-]*$'

/**
 * Regular expression used to validate a schema name.
 */

const schemaNamePattern = '^[a-z0-9_]*$'

/**
 * Regular expression used to validate an email address.
 */

const emailPattern = '^.+\@.+\..+$' // eslint-disable-line

/**
 * Regular expression used to validate a password.
 *
 * Critera is between 8 and 100 characters and 1 number
 */

const passwordPattern = '^(?=.*[0-9]).{8,100}$'
const passwordErrorMessage = 'Your password needs to be between 8 and 100 characters long and include at least 1 number.'

/**
 * Exports.
 */

export {
  validateCompanyName,
  validatePassword,
  validateEmail,
  validateName,
  validateSchemaName,
  validateSlug,
  validateUrl,
  passwordPattern,
  passwordErrorMessage,
  emailPattern,
  schemaNamePattern,
  slugPattern,
  validateWarehouseUsername,
  validateWarehousePassword,
  validateWarehouseHostname,
  validateDatabase,
  validatePort
}

/**
 * Validate name.
 */

function validateName (validity, el) {
  if (validity.valueMissing) return 'Please enter a name.'
  return el.validationMessage
}

/**
 * Validate schema name.
 */

function validateSchemaName (validity, el) {
  if (validity.valueMissing) return 'Please enter a schema name.'
  if (validity.patternMismatch) return 'Please enter a schema name without dashes, slashes, special characters, or capital letters.'
  return el.validationMessage
}

/**
 * Validate slug.
 */

function validateSlug (validity, el) {
  if (validity.valueMissing) return 'Please enter a slug.'
  if (validity.patternMismatch) return 'Please enter a slug without slashes, special characters, or capital letters.'
  return el.validationMessage
}

/**
 * Validate email.
 */

function validateEmail (validity, el) {
  if (validity.valueMissing) return 'Please enter an email address.'
  if (validity.patternMismatch || validity.typeMismatch) 'Please enter a valid email address.'
  return el.validationMessage
}

/**
 * Validate url.
 */

function validateUrl (validity, el) {
  if (validity.typeMismatch) return 'Please enter a valid url. Please include "https:// or http://"'
  return el.validationMessage
}

/**
 * Validate password.
 */

function validatePassword (validity, el) {
  if (validity.valueMissing) return 'Please enter a password.'
  if (validity.patternMismatch) return passwordErrorMessage
  return el.validationMessage
}

/**
 * Validate company name.
 */

function validateCompanyName (validity, el) {
  if (validity.valueMissing) return 'Please enter your company name.'
  return el.validationMessage
}

/**
 * Validate warehouse username.
 */

function validateWarehouseUsername (validity, el) {
  if (validity.valueMissing) return 'Please enter a user. Be sure they have write access so we can load your data!'
  return el.validationMessage
}

/**
 * Validate warehouse password.
 */

function validateWarehousePassword (validity, el) {
  if (validity.valueMissing) return 'Please enter the password for the user who has write access.'
  return el.validationMessage
}

/**
 * Validate warehouse hostname.
 */

function validateWarehouseHostname (validity, el) {
  if (validity.valueMissing) return 'Please enter the host where your database lives.'
  return el.validationMessage
}

/**
 * Validate database.
 */

function validateDatabase (validity, el) {
  if (validity.valueMissing) return 'Please enter the name of the database we should write to.'
  return el.validationMessage
}

/**
 * Validate port.
 */

function validatePort (validity, el) {
  if (validity.valueMissing) return 'Please enter a port.'
  if (validity.patternMismatch) return 'Port must be a number.'
  return el.validationMessage
}



// WEBPACK FOOTER //
// ./lib/validation/index.js